module.exports = __webpack_public_path__ + "img/bg-dark1.e7438acd.jpg";